import { styled, Typography } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

// https://www.figma.com/file/oy0lqfg1RnOZ1Y7129AJmc/KAIZEN-Design-Library?node-id=40%3A11173
const BodyBold = styled(Typography)({
  fontWeight: 700,
  fontSize: '14px',
  fontStyle: 'normal',
  color: COLOR_TEXT_MAIN,
  lineHeight: '100%',
  letterSpacing: '0.01em',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
  '& a': {
    color: COLOR_TEXT_MAIN,
    textDecoration: 'none',
  },
});

export const BodyBoldStyle = {
  fontWeight: 700,
  fontSize: '14px',
  fontStyle: 'normal',
  color: COLOR_TEXT_MAIN,
  lineHeight: '160%',
  letterSpacing: '0.01em',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
};
export default BodyBold;
